<template>
<div class="chapter">
<div class="inner_page">
<p class="half-title1"><a id="page_xv"></a><em>Cradle of Gold</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780230337411_09a_hlf1.vue?3cd85372